﻿$.fn.dxCtrlContentSondagePageLst = function custom_dxCtrlContentSondagePageLst(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlcontentsondagepagelst dx-ctrl");
        this.createInstance(new cdxCtrlContentSondagePageLst(this, option));
    }
    return this;
}

window.cdxCtrlContentSondagePageLst = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var $DivLstPage = null
    var $DivDetailPage = null
    var sondage = null
    var $ContentElementQuestion = null
    function mConstruit() {
        container.empty()

        if (option.dataSondage.jsonquestion == null) option.dataSondage.jsonquestion = JSON.stringify({
            last_id_page: 0,
            lst_page: []
        })
        if (option.dataSondage.jsonfin == null) option.dataSondage.jsonfin = JSON.stringify({
            titre: "Conclusion",
            id_page: -1,
            lst_question: [],
            last_id_question: 0,
            affiche_titre: true,
            link_img: "",
            position_img: "Aléatoire"
        })
        sondage = new cSondage({ bddCtrl: option.bddCtrl, dataSondage: option.dataSondage })

        ctrlResize = $("<div style='width:100%;height:100%;margin-top:5px;'/>").appendTo(container).dxCtrlSplitterResize2({
            bddCtrl: option.bddCtrl,
            context_grid: "splitresizesondage",
            withMarge: false,
            widthLeftInitial: 400
        }).dxCtrlSplitterResize2("instance")
        ctrlResize.mConstruitLeft(function (contentElement) {
            mRempliLstPage(contentElement)
        })
        ctrlResize.mConstruitRight(function (contentElement) {
            $ContentElementQuestion = contentElement
        })



        ////if (option.dataSondage.jsonintro == null) option.dataSondage.jsonintro = JSON.stringify({
        ////    id_grp: 1,
        ////    type: "text",
        ////    lstPhrase: [""]
        ////})
        ////if (option.dataSondage.jsonfin == null) option.dataSondage.jsonfin = JSON.stringify({
        ////    id: 1,
        ////    type: "text",
        ////    lstPhrase: [""]
        ////})
        //sondage = new cSondage({ bddCtrl: option.bddCtrl, dataSondage: option.dataSondage })

        //var $DivEntete = $("<div/>").appendTo(container)
        ////var $Table = $("<table style='width:100%;table-layout:fixed'/>").appendTo($DivEntete)
        ////var $Tr = $("<tr/>").appendTo($Table)
        ////var $Td = $("<td style='width:100%;'/>").appendTo($Tr)
        ////var $Td = $("<td style='width:36px;vertical-align:top;'/>").appendTo($Tr)
        ////$("<div/>").appendTo($Td).dxCtrlButton({
        ////    icon: "fas fa-plus",
        ////    hint: "Ajouter une page de question",
        ////    onClick: function (e) {
        ////        var newPage = sondage.mCreateNewPage()
        ////        mRempliList()
        ////    }
        ////})

        //var $DivDetail = $("<div style='position:relative'/>").appendTo(container)
        //$DivLstPage = $("<div style='position:absolute;width:100%;height:100%;top:0;left:0;z-index:0;'/>").appendTo($DivDetail)
        //$DivDetailPage = $("<div style='position:absolute;width:100%;height:100%;top:0;left:0;z-index:1;display:none;'/>").appendTo($DivDetail)

        //var $DivPied = $("<div/>").appendTo(container)

        //resizeObserver.mAdd([$DivEntete, $DivPied], function () {
        //    $DivDetail.css("height", "calc(100% - " + ($DivEntete.innerHeight() + $DivPied.innerHeight() + 5) + "px)")
        //})()

        //mRempliLstPage()
    }

    function mRempliLstPage(contentElement) {
        contentElement.css("padding-right", "5px")
        var $DivTitle = $("<div/>").appendTo(contentElement)

        var $Table = $("<table style='width:100%;table-layout:fixed'/>").appendTo($DivTitle)
        var $Tr = $("<tr/>").appendTo($Table)
        var $Td = $("<td style='width:100%;font-size:120%;font-weight:bold;'>Liste des pages</td>").appendTo($Tr)
        var $Td = $("<td style='width:36px;vertical-align:top;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-file",
            icon2: "fas fa-plus",
            hint: "Créer une nouvelle page de question",
            onClick: function (e) {
                mSaisieTitrePage("", function (title) {
                    var newPage = sondage.mCreateNewPage(title)
                    mConstruitLstPage(newPage)
                    mRempliPage(newPage, function () {
                        mConstruitLstPage()
                    })
                })
            }
        })

        var $DivDetailLstPage = $("<div class='lstpage'/>").appendTo(contentElement)
        var dxListPage = null
        mConstruitLstPage()
        function mConstruitLstPage(newSelectedItems) {
            var selectedItems = []
            if (dxListPage) selectedItems = dxListPage.option("selectedItems")
            if (newSelectedItems) selectedItems = [newSelectedItems]
            $DivDetailLstPage.empty()
            dxListPage = $("<div style='height:100%'/>").appendTo($DivDetailLstPage).dxList({
                //dataSource: sondage.jsonQuestion.lst_page,
                dataSource: new DevExpress.data.DataSource({
                    store: new DevExpress.data.ArrayStore({
                        data: sondage.jsonQuestion.lst_page,
                        key: "id_page"
                    }),
                    paginate: false,
                    reshapeOnPush: true
                }),
                selectedItems: selectedItems,
                noDataText: "(aucune page)",
                allowItemDeleting: true,
                itemDeleteMode: 'toggle',
                onItemDeleted: function () {
                    sondage.mSave()
                },
                //repaintChangesOnly: true,
                selectionMode: 'single',
                itemDragging: {
                    allowReordering: true,
                    data: sondage.jsonQuestion.lst_page,
                    group: 'pages',
                    onDragStart(e) {
                        e.itemData = e.fromData[e.fromIndex];
                    },
                    //onAdd(e) {
                    //    e.toData.splice(e.toIndex, 0, e.itemData);
                    //    e.component.reload();
                    //},
                    //onRemove(e) {
                    //    e.fromData.splice(e.fromIndex, 1);
                    //    e.component.reload();
                    //},
                    onReorder({
                        fromIndex, toIndex, fromData, component,
                    }) {
                        const item = fromData.splice(fromIndex, 1)[0];
                        sondage.jsonQuestion.lst_page.splice(toIndex, 0, item);
                        sondage.mSave()
                        component.reload();
                    },
                },
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    itemElement.empty()
                    itemElement.css("padding", "5px")
                    var $Div = $("<div style='padding:5px;border:" + theme.border + ";box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);'/>").appendTo(itemElement)
                    var $Table = $("<table style='width:100%;table-layout:fixed'/>").appendTo($Div)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Tr)
                    $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Td).dxCtrlContentSondagePageItem({
                        bddCtrl: option.bddCtrl,
                        dataPage: itemData
                    })

                    var $Td = $("<td style='width:36px;vertical-align:top;'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        icon: "fas fa-arrow-up-right-from-square",
                        hint: "afficher la page dans prévisualisation",
                        height: 30,
                        width: 30,
                        onClick: function (e) {
                            e.event.stopPropagation()
                            $("<div/>").appendTo("body").dxCtrlPreviSondage({
                                bddCtrl: option.bddCtrl,
                                idSondage: option.dataSondage.id_sondage,
                                dataSondage: option.dataSondage,
                                url: parametre.url_appli + "/" + option.bddCtrl.nom_base + "/" + option.dataSondage.id_sondage + "/0/0/0/0/1/sondage",
                                indexSelectedPage: sondage.jsonQuestion.lst_page.indexOf(itemData)
                            })
                        }
                    })
                },
                onItemClick: function (e) {
                    var itemData = e.itemData
                    if (!itemData) itemData = sondage.jsonQuestion.lst_page[e.itemIndex]
                    $DivFooterInner.removeClass("dx-item dx-list-item dx-list-item-selected")
                    mRempliPage(itemData, function () {
                        mConstruitLstPage()
                    })
                }
            }).dxList("instance")
        }

        var $DivFooter = $("<div class='state-hover dx-list' styel='padding:5px;'/>").appendTo(contentElement)
        var $DivFooterInner = $("<div style='padding:5px;border:" + theme.border + ";box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);width:100%;margin:0;'/>").appendTo($DivFooter)
        mContruitFooter()
        function mContruitFooter() {
            $DivFooterInner.empty()
            $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-height:37px;display:flex;align-items:center;'/>").appendTo($DivFooterInner).dxCtrlContentSondagePageItem({
                bddCtrl: option.bddCtrl,
                dataPage: sondage.jsonFin
            })
            $DivFooter.off("click")
            $DivFooter.on("click", function (e) {
                dxListPage.option("selectedItems", [])
                $DivFooterInner.addClass("dx-item dx-list-item dx-list-item-selected")
                mRempliPage(sondage.jsonFin, function () {
                    mContruitFooter()
                }, true)
            })
        }


        resizeObserver.mAdd([$DivTitle, $DivFooter], function () {
            $DivDetailLstPage.css("height", "calc(100% - " + ($DivTitle.innerHeight() + $DivFooter.innerHeight() + 5) + "px)")
        })()
    }

    function mSaisieTitrePage(title, funcOk) {
        var dxTitle = null
        mConfirmPopup(function (contentElement) {
            dxTitle = $("<div/>").appendTo(contentElement).dxCtrlTextBox({
                labelMode: "floating",
                label: "Titre de la page",
                value: title,
                onContentReady: function (e) {
                    window.setTimeout(function () { e.component.focus() }, 600)
                }
            }).dxCtrlTextBox("instance")
        }, function (pop) { //on confirm
            if (!dxTitle.option("value") && dxTitle.option("value").length == 0) {
                mNotify("Veuillez saisir un titre pour la page", "warning", 6000)
                return
            }
            funcOk(dxTitle.option("value"))
        },
            "Créer page",
            null, //annuler
            "Annuler",
            null, //onHiding
            true, //showTitle
            "Création d'une page")
    }

    function mRempliPage(page, onValueChanged, isJsonFin) {
        $ContentElementQuestion.empty()
        var $DivTitle = $("<div/>").appendTo($ContentElementQuestion)

        var $TablePage = $("<table style='width:90%;margin:0 5% 0px 5%;'/>").appendTo($DivTitle)
        var $Tr = $("<tr/>").appendTo($TablePage)
        var $Td = $("<td style='width:100%;border:" + theme.border + ";border-radius:10px;padding:0 20px;'/>").appendTo($Tr)
        $("<div style='margin:8px 0;'/>").appendTo($Td).dxCtrlTextBox({
            labelMode: "floating",
            label: "Titre de la page",
            value: page.titre,
            onValueChanged: function (e) {
                if (e.value == null || e.value.length == 0) {
                    e.component.option("value", page.titre)
                }
                page.titre = e.value
                sondage.mSave()
                if (onValueChanged) onValueChanged()
            },
            onContentReady: function (e) {
                e.component.element().find("input").css("font-weight", "bold")
            }
        })

        $("<div style='margin:8px 0;'/>").appendTo($Td).dxCheckBox({
            value: page.affiche_titre,
            text: "Afficher le titre dans la page",
            hint: "Quand le destinataire affiche la page, le titre est affiché au début de la page",
            onValueChanged: function (e) {
                page.affiche_titre = e.value
                sondage.mSave()
                if (onValueChanged) onValueChanged()
            }
        })

        var $TableImage = $("<table style='width:100%;margin:8px 0;'/>").appendTo($Td)
        var $TrImg = $("<tr/>").appendTo($TableImage)
        var $TdImg = $("<td style='width:100%;'/>").appendTo($TrImg)
        var dxTextBoxLink = $("<div/>").appendTo($TdImg).dxCtrlTextBox({
            bddCtrl: option.bddCtrl,
            labelMode: "floating",
            label: "Lien sur une image pour illustrer la page",
            value: page.link_img,
            onValueChanged: function (e) {
                var lien = ((e.value == null) ? "" : e.value)
                if (!lien.startsWith("http://") && !lien.startsWith("https://") && !lien.startsWith("ftp://") && !lien.startsWith("ftps://")) {
                    lien = "http://" + lien
                }
                page.link_img = lien
                sondage.mSave()
                if (onValueChanged) onValueChanged()
            }
        }).dxCtrlTextBox("instance")
        var $TdImg = $("<td style='width:1px;'/>").appendTo($TrImg)
        $("<div/>").appendTo($TdImg).dxCtrlButton({
            icon: "fas fa-boxes",
            hint: "Choisissez un fichier dans votre box<br/>(Vous pouvez choisir un fichier image dans votre box publique. si le fichier est sur votre machine, il vous suffit de le déposer dans le répertoire public de votre box, puis de le sélectionner)",
            onClick: function (e) {
                var pop = $("<div/>").appendTo($DivGeneral).dxCtrlFileUploaderPopup({
                    bddCtrl: option.bddCtrl,
                    machine: false,
                    box: true,
                    icone: false,
                    imgInternet: false,
                    docCpt: false,
                    courrier: false,
                    multiple: false,
                    optionBox: {
                        allowRepertoirePublic: true,
                        allowRepertoirePartage: false,
                        allowRepertoireUti: false
                    },
                    onValide: function (lstUrlFile) {
                        if (lstUrlFile.length > 0) {
                            var fic = new cFichier(option.bddCtrl, lstUrlFile[0])
                            var url = fic.urlPublicAbsolue()
                            if (url.length > 0) {
                                dxTextBoxLink.option("value", url)
                                //link.link = url
                                //option.value = link.link
                                //option.onValueChanged(link)
                                mNotify("Vous avez inséré un lien sur un document de votre box public", "success", 6000)
                            }
                        }
                        pop.hide();
                    }
                }).dxCtrlFileUploaderPopup("instance")
            }
        })

        $("<div style='margin-bottom:8px;'/>").appendTo($Td).dxSelectBox({
            labelMode: "floating",
            label: "Position",
            placeholder: "",
            dataSource: ["Aléatoire", "Haut", "Droite", "Bas", "Gauche"],
            value: page.position_img,
            onValueChanged: function (e) {
                page.position_img = e.value
                sondage.mSave()
                if (onValueChanged) onValueChanged()
            }
        })

        var $Td = $("<td style='width:1px;vertical-align:bottom;'/>").appendTo($Tr)
        $("<div/>").appendTo($Td).dxCtrlButton({
            icon: "fas fa-circle-question",
            icon2: "fas fa-plus",
            hint: "Ajouter une nouvelle question/texte",
            onClick: function (e) {
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: e.component.element(),
                    contentTemplate: function (contentElement) {
                        contentElement.css("padding", "20px")
                        if (!isJsonFin) {
                            $("<div style='margin:5px 0;'/>").appendTo(contentElement).dxCtrlButton({
                                text: "Oui/Non",
                                width: "100%",
                                hint: "<div style='text-align:left;'>Permet de déterminer si la question suivante doit être affichée:<br/>si la réponse est<strong>Oui</strong>, la ou les questions suivantes sont affichées(jusqu'au prochaine OUI/NON ou jusqu'à la fin);<br/>si la réponse est <strong> Non</strong>, les questions dépendantes sont ignorées et l'utilisateur peut passer à la page suivante.<br/>exemple:<br/>« Utilisez-vous ce service ? »<br/> → <strong>Oui</strong>: affichage des questions complémentaires;<br/> → <strong>Non</strong>: possibilité de passer à la page suivante.</div>",
                                onClick: function (e) {
                                    var newQuestion = sondage.mCreateNewQuestionFromPage(page, "ouinon")
                                    mShowQuestion(page, newQuestion, function () {
                                        mConstruitLstQuestion()
                                        if (onValueChanged) onValueChanged()
                                    })
                                    mConstruitLstQuestion()
                                    if (onValueChanged) onValueChanged()
                                }
                            })
                            $("<div style='margin:5px 0;'/>").appendTo(contentElement).dxCtrlButton({
                                text: "Choix multiple",
                                width: "100%",
                                hint: "Liste de réponses avec plusieurs choix possibles.",
                                onClick: function (e) {
                                    var newQuestion = sondage.mCreateNewQuestionFromPage(page, "chk")
                                    mShowQuestion(page, newQuestion, function () {
                                        mConstruitLstQuestion()
                                        if (onValueChanged) onValueChanged()
                                    })
                                    mConstruitLstQuestion()
                                    if (onValueChanged) onValueChanged()
                                }
                            })
                            //$("<br/>").appendTo(contentElement)
                            $("<div style='margin:5px 0;'/>").appendTo(contentElement).dxCtrlButton({
                                text: "Choix unique",
                                width: "100%",
                                hint: "Liste de réponses avec un seul choix possible.<br/>C'est sur ce type de question qu'est calculé le taux de satisfaction.",
                                onClick: function (e) {
                                    var newQuestion = sondage.mCreateNewQuestionFromPage(page, "radio")
                                    mShowQuestion(page, newQuestion, function () {
                                        mConstruitLstQuestion()
                                        if (onValueChanged) onValueChanged()
                                    })
                                    mConstruitLstQuestion()
                                    if (onValueChanged) onValueChanged()
                                }
                            })
                            //$("<br/>").appendTo(contentElement)
                        }
                        $("<div style='margin:5px 0;'/>").appendTo(contentElement).dxCtrlButton({
                            text: "Saisie libre",
                            width: "100%",
                            hint: "Zone de texte libre pour recueillir l'avis du répondeur",
                            onClick: function (e) {
                                var newQuestion = sondage.mCreateNewQuestionFromPage(page, "textbox")
                                mShowQuestion(page, newQuestion, function () {
                                    mConstruitLstQuestion()
                                    if (onValueChanged) onValueChanged()
                                })
                                mConstruitLstQuestion()
                                if (onValueChanged) onValueChanged()
                            }
                        })
                        //$("<br/>").appendTo(contentElement)
                        $("<div style='margin:5px 0;'/>").appendTo(contentElement).dxCtrlButton({
                            text: "Texte fixe",
                            width: "100%",
                            hint: "Saisissez un texte qui sera affiché",
                            onClick: function (e) {
                                var newQuestion = sondage.mCreateNewQuestionFromPage(page, "text")
                                mShowQuestion(page, newQuestion, function () {
                                    mConstruitLstQuestion()
                                    if (onValueChanged) onValueChanged()
                                })
                                mConstruitLstQuestion()
                                if (onValueChanged) onValueChanged()
                            }
                        })
                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            }
        })

        var $DivDetailLstQuestion = $("<div/>").appendTo($ContentElementQuestion)
        mConstruitLstQuestion()
        function mConstruitLstQuestion() {
            $DivDetailLstQuestion.empty()
            var dxListQuestion = $("<div style='height:100%'/>").appendTo($DivDetailLstQuestion).dxList({
                //dataSource: page.lst_question,
                dataSource: new DevExpress.data.DataSource({
                    store: new DevExpress.data.ArrayStore({
                        data: page.lst_question,
                        key: "id_question"
                    }),
                    paginate: false,
                    reshapeOnPush: true
                }),
                keyExpr: "id_question",
                noDataText: "(Aucune question sur cette page)",
                allowItemDeleting: true,
                itemDeleteMode: 'toggle',
                onItemDeleted: function () {
                    sondage.mSave()
                },
                //repaintChangesOnly: true,
                itemDragging: {
                    allowReordering: true,
                    data: page.lst_question,
                    group: 'questions',
                    onDragStart(e) {
                        e.itemData = e.fromData[e.fromIndex];
                    },
                    //onAdd(e) {
                    //    e.toData.splice(e.toIndex, 0, e.itemData);
                    //    e.component.reload();
                    //},
                    //onRemove(e) {
                    //    e.fromData.splice(e.fromIndex, 1);
                    //    e.component.reload();
                    //},
                    onReorder({
                        fromIndex, toIndex, fromData, component,
                    }) {
                        const item = fromData.splice(fromIndex, 1)[0];
                        page.lst_question.splice(toIndex, 0, item);
                        sondage.mSave()
                        component.reload();
                        if (onValueChanged) onValueChanged()
                    },
                },
                itemTemplate: function (itemData, itemIndex, itemElement) {
                    itemElement.css("padding", "5px")
                    var $Div = $("<div style='padding:5px;border:" + theme.border + ";box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);'/>").appendTo(itemElement)
                    var $Table = $("<table style='width:100%;table-layout:fixed'/>").appendTo($Div)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $Td = $("<td style='width:100%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Tr)
                    $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;'/>").appendTo($Td).dxCtrlContentSondagePageQuestionItem({
                        bddCtrl: option.bddCtrl,
                        dataQuestion: itemData
                    })
                    var $Td = $("<td style='width:36px;vertical-align:top;'/>").appendTo($Tr)
                    $("<div/>").appendTo($Td).dxCtrlButton({
                        icon: "fas fa-copy",
                        hint: "Dupliquer",
                        onClick: function (e) {
                            var newItemData = JSON.parse(JSON.stringify(itemData))
                            page.lst_question.splice(itemIndex, 0, newItemData);
                            mConstruitLstQuestion()
                            if (onValueChanged) onValueChanged()
                            mShowQuestion(page, newItemData, function () {
                                mConstruitLstQuestion()
                                if (onValueChanged) onValueChanged()
                            }, isJsonFin)
                        }
                    })
                },
                onItemClick: function (e) {
                    var itemData = e.itemData
                    if (!itemData) itemData = page.lst_question[e.itemIndex]
                    mShowQuestion(page, itemData, function () {
                        mConstruitLstQuestion()
                        if (onValueChanged) onValueChanged()
                    }, isJsonFin)
                }
            }).dxList("instance")
        }


        resizeObserver.mAdd([$DivTitle], function () {
            $DivDetailLstQuestion.css("height", "calc(100% - " + ($DivTitle.innerHeight() + 5) + "px)")
        })()

        //$DivDetailPage.slideDown(200);

    }

    function mShowQuestion(page, question, onValueChanged, isJsonFin) {
        var title = ""
        switch (question.type) {
            case "ouinon":
                title = "Question oui/non"
                break;
            case "chk":
                title = "Liste à choix multiple"
                break;
            case "radio":
                title = "Liste à choix unique"
                break;
            case "textbox":
                title = "Zone de saisie libre"
                break;
            case "text":
                title = "Texte d'explication"
                break;
        }
        var popright = $("<div/>").appendTo("body").dxCtrlPopupRightTranslate({
            title: title,
            closeOnOutSideClick: false,
            contentTemplate: function (contentElement) {
                switch (question.type) {
                    case "ouinon":
                        $("<div/>").appendTo(contentElement).dxCtrlSondageQuestionOuiNon({
                            bddCtrl: option.bddCtrl,
                            sondage: sondage,
                            dataPage: page,
                            dataQuestion: question,
                            onValueChanged: onValueChanged,
                            isJsonFin: isJsonFin
                        })
                        break;
                    case "chk":
                        $("<div/>").appendTo(contentElement).dxCtrlSondageQuestionChk({
                            bddCtrl: option.bddCtrl,
                            sondage: sondage,
                            dataPage: page,
                            dataQuestion: question,
                            onValueChanged: onValueChanged,
                            isJsonFin: isJsonFin
                        })
                        break;
                    case "radio":
                        $("<div/>").appendTo(contentElement).dxCtrlSondageQuestionRadio({
                            bddCtrl: option.bddCtrl,
                            sondage: sondage,
                            dataPage: page,
                            dataQuestion: question,
                            onValueChanged: onValueChanged,
                            isJsonFin: isJsonFin
                        })
                        break;
                    case "textbox":
                        $("<div/>").appendTo(contentElement).dxCtrlSondageQuestionTextBox({
                            bddCtrl: option.bddCtrl,
                            sondage: sondage,
                            dataPage: page,
                            dataQuestion: question,
                            onValueChanged: onValueChanged,
                            isJsonFin: isJsonFin
                        })
                        break;
                    case "text":
                        $("<div/>").appendTo(contentElement).dxCtrlSondageQuestionText({
                            bddCtrl: option.bddCtrl,
                            sondage: sondage,
                            dataPage: page,
                            dataQuestion: question,
                            onValueChanged: onValueChanged,
                            isJsonFin: isJsonFin
                        })
                        break;
                }
            }
        }).dxCtrlPopupRightTranslate("instance")
    }

    this.element = function () { return container }

    mConstruit();
}